import { API } from '../config/api';
import { DataService } from '../config/dataService/dataService';

class AuthService {
  static DUPLICATE_SESSION = 'DUPLICATE_SESSION';

  static async login(email, password, forceLogin = false) {
    const { data } = await DataService.post(API.auth.login, { email, password, forceLogin });
    return {
      user: data.user,
      token: data.token,
      accountData: data.accountData,
      accountModules: data.accountModules
    };
  }

  static async logout() {
    await DataService.post(API.auth.logout);
  }

  static async getCurrentUser() {
    const { data } = await DataService.get(API.auth.currentUser);
    return {
      user: data.user,
      accountData: data.accountData,
      accountModules: data.accountModules,
    };
  }

  static async registerActivity() {
    try {
      await DataService.post(API.auth.activity);
    } catch (error) {
      console.error('Error registering activity:', error);
    }
  }
}

export { AuthService };
